/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  input: {
    color: 'red !important',
  },
}));
export default function ColorTabs(props) {
  const classes = useStyles();

  const { tabValue, handleChangeTabValue } = props;

  const tabData = [
    { label: 'Identification', value: 'one' },
    { label: 'Financial', value: 'two' },
    { label: 'Dates', value: 'three' },
    { label: 'Others', value: 'four' },
  ];

  return (
    <>
      <div className={classes.root}>
        <AppBar position="static" sx={{ width: '100%' }}>
          <Tabs
            value={tabValue}
            onChange={handleChangeTabValue}
            color="red"
            style={{ color: 'red' }}
          >
            {tabData.map((item, index) => (
              <Tab
                className={`${index == 0 ? 'width-130' : ''}`}
                key={index}
                style={{
                  textTransform: 'capitalize',
                }}
                value={item.value}
                label={item.label}
                tabIndex={0}
              />
            ))}
          </Tabs>
        </AppBar>
      </div>
    </>
  );
}
